
import { Component, OnInit } from '@angular/core';
import { AuthService } from 'src/app/services/auth.service';
import { LedgerService } from 'src/app/services/ledger.service';


@Component({
  selector: 'app-coins-history',
  templateUrl: './coins-history.component.html',
  styleUrls: ['./coins-history.component.scss'],
})
export class CoinsHistoryComponent implements OnInit {
  history = [];
  unsub1;
  currentUser = this.authService.currentUser;

  constructor(
    public authService: AuthService,
    public ledgerService: LedgerService,
  ) {
    this.unsub1 = this.authService.currentAccount.subscribe(async (user) => {
      if (user) {
        this.currentUser = user;
        this.getHistory(undefined);
      }
    });
    this.unsub1 = this.ledgerService.ledgerUpdate.subscribe(async (ledger) => { this.getHistory(ledger); });
   }

  ngOnInit() {}



  getHistory(ledger) {
    ledger =  ledger ? ledger : this.ledgerService.ledger;
    this.history = ledger?.history || [];
    console.log(this.history);
  }


  ionviewDidLeave() {
    this.unsub1.unsubscribe();
  }

}
